import type { PlanV3 } from "../../utils/types";
import type { GroupedSmartSurveyorElement } from "components/SmartSurveyor/ReviewPage/types";

export const EMPTY_BY_GROUP: Record<string, GroupedSmartSurveyorElement[]> = {};
export const EMPTY_ARRAY: string[] = [];
export const EMPTY_GROUP_META: PlanV3["groupMeta"] = {};
export const ALL_ELEMENTS_GROUP_LABEL = "__all__" as const;
